module.exports = "/_next/static/images/customer-review-claudia-min-2bd542853f3cbf1b0dd54a4ce4a21911.png.webp";